import { createFileRoute, notFound } from '@tanstack/react-router';

import { DocsNotFoundPage, EndpointPage, findOperation } from '@/features/docs';

export const Route = createFileRoute('/_authed/docs/api/$tag/$operation')({
  loader: ({ params }) => {
    const operation = findOperation(params.tag, params.operation);
    if (!operation) throw notFound();
    return operation;
  },
  component: function EndpointRoute() {
    return <EndpointPage operation={Route.useLoaderData()} />;
  },
  notFoundComponent: DocsNotFoundPage,
});
